import React from 'react';
import Heading from '@atlaskit/heading';
import { Box, xcss } from '@atlaskit/primitives';
import type { TriggerProps } from '@atlaskit/tooltip';

const IssueInfo = ({
	issueType,
	issueKey,
	issueSummary,
	iconUrl,
	tooltipProps,
}: {
	issueType: string;
	issueKey: string;
	issueSummary: string;
	iconUrl: string;
	tooltipProps?: TriggerProps;
}) => (
	// eslint-disable-next-line react/jsx-props-no-spreading
	<Box {...tooltipProps} xcss={issueInfoStyles}>
		<img src={iconUrl} alt={issueType} />
		<Heading size="xxsmall" as="span">
			<Box as="span" xcss={noWrapStyles}>
				{issueKey}
			</Box>
		</Heading>
		<Box as="span" xcss={issueSummaryStyles}>
			{issueSummary}
		</Box>
	</Box>
);

const issueInfoStyles = xcss({
	display: 'flex',
	alignItems: 'center',
	gap: 'space.100',
});

const issueSummaryStyles = xcss({
	overflow: 'hidden',
	whiteSpace: 'nowrap',
	textOverflow: 'ellipsis',
});

const noWrapStyles = xcss({
	whiteSpace: 'nowrap',
});

export default IssueInfo;
